import { createClient, type SanityClient } from "@sanity/client";
import imageUrlBuilder, { type SanityImageSource } from "@sanity/image-url";
import {
  SANITY_API_VERSION,
  SANITY_DATASET,
  SANITY_PROJECT_ID,
} from "./constants";

let client: SanityClient | undefined;

// Lazily constructed so importing this module (or the blog components that
// use it) never throws on app boot if REACT_APP_SANITY_PROJECT_ID isn't set
// yet — the error only surfaces when a blog page actually queries Sanity.
export const getSanityClient = (): SanityClient => {
  if (!client) {
    client = createClient({
      projectId: SANITY_PROJECT_ID,
      dataset: SANITY_DATASET,
      apiVersion: SANITY_API_VERSION,
      useCdn: true,
    });
  }

  return client;
};

export const urlForImage = (source: SanityImageSource) =>
  imageUrlBuilder(getSanityClient()).image(source);
